








































































import {Vue, Component, Watch} from 'vue-property-decorator';
import {popupResize} from '@/utils/ncp';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import countrys from '@/const/words/deliveryCountry';
import {Areafee, PutAreafeesByAreaFeeNoRequest, AreafeeDetail} from 'supporter';
// import country from '../../const/words/country';

@Component({
  components: {
    CompSelectBox
  }
})
export default class DeliveryAreaFeeModifyForm extends Vue {
  private areaFee: Areafee | null = null;
  private countrys = countrys;
  private CA = '';
  @Watch('areaFee.countryCd')
  onCountryCdChanged(newVal: string, oldVal: string) {
    if (oldVal) {
      this.$api
        .getAreas({
          params: {
            countryCd: newVal
          }
        })
        .then(ret => {
          const details: AreafeeDetail[] = [];
          ret.data.forEach(item => {
            details.push({
              address: item.address,
              areaNo: item.areaNo,
              state: item.state,
              extraDeliveryAmt: 0.0
            });
          });
          (this.areaFee as Areafee).details = details;
        });
    }
  }
  fetchAreaFee(areaFeeNo: number) {
    this.$api
      .getAreafeesByAreaFeeNo({
        params: {
          areaFeeNo: String(areaFeeNo)
        }
      })
      .then(ret => {
        if (ret && ret.data) {
          this.areaFee = ret.data;
        }
      });
  }
  created() {
    const areaFeeNo = this.$route.query.deliveryAreaFeeNo;
    this.fetchAreaFee(Number(areaFeeNo));
  }
  updated() {
    if ((this.$refs.countryCode as any).value == this.countrys[1].value) {
      this.CA = (this.$refs.countryCode as any).value;
    }
  }
  cancel() {
    if (confirm(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_ADD_CONFIRM1').toString())) {
      window.close();
    }
  }
  save() {
    const areaFee = this.areaFee as Areafee;
    let isValid = true;
    if (!areaFee.name) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_ADD_ALERT1'));
      (this.$refs.deliveryAreaFeeName as any).focus();
      return;
    }
    let ref = '';
    areaFee.details.forEach(detail => {
      if (typeof detail.extraDeliveryAmt === 'string' && !detail.extraDeliveryAmt) {
        isValid = false;
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_ADD_ALERT2'));
        ref = 'extraDeliveryAmt' + detail.areaNo;
        (this.$refs[ref] as any)[0].focus();
        return;
      }
    });
    if (!isValid) {
      return;
    }
    const putRequest: PutAreafeesByAreaFeeNoRequest = {
      params: {
        areaFeeNo: areaFee.areaFeeNo
      },
      data: {
        name: areaFee.name,
        countryCd: areaFee.countryCd,
        details: areaFee.details
      }
    };
    this.$api.putAreafeesByAreaFeeNo(putRequest).then(() => {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_ADD_ALERT3'));
      window.opener.location.reload();
      window.close();
    });
  }
  checkNumber(index: number, event: Event) {
    const value = (event.target as HTMLInputElement).value;
    const result = value.replace(/[^0-9]/g, '');
    (event.target as HTMLInputElement).value = result;
    if (value !== result) {
      (document.querySelector(`#errorextraDeliveryAmt${index}`) as HTMLDivElement).style.display = 'block';
    } else {
      (document.querySelector(`#errorextraDeliveryAmt${index}`) as HTMLDivElement).style.display = 'none';
    }
  }
  hideNumber(index: number) {
    (document.querySelector(`#errorextraDeliveryAmt${index}`) as HTMLDivElement).style.display = 'none';
  }
  private async mounted() {
    this.$nextTick(() => {
      popupResize(undefined, 1500);
    });
  }
}
